import type { SchemaOwner } from '@cli-types/preset-engine/presets.js'

export function presetIdFromOwner(owner: SchemaOwner): string | null {
  return owner.startsWith('preset:') ? owner.replace(/^preset:/, '') : null
}
